export const insertModuleTypes = [
    'AD',
    'ARRI',
    'BD',
    'BDALG',
    'BDBASE',
    'BDEVENT',
    'BDLOGIC',
    'BDRULE',
    'BDSUMMARY',
    'BF',
    'BFDATAFLOW',
    'CDT',
    'CDTSEQVAL',
    'DE',
    'DF',
    'DO',
    'DT',
    'DV',
    'FC',
    'IE',
    'LSI',
    'OR',
    'OU',
    'RULEMRMRULE',
    'UC',
    'UE',
    'UI',
    'UIALG',
    'UIRULE',
    'UV',
]

export const menuItemsInsertExternal = (map) => {
    return [
        {
            type: '_E',
            label: '外部项目模件',

            children: [
                {type: 'OU_1', label: '组织单元'},
                {type: 'OR_1', label: '岗位角色'},
                {type: 'DO_1', label: '维度对象'},
                {type: 'DE_1', label: '维度实体'},
                {type: 'IE_1', label: '指标实体'},
                {type: 'AD_1', label: '分析维度'},
                {type: 'UI_1', label: '用户界面'},
                {type: 'UE_2', label: '界面事件'},
                {type: 'BDSUMMARY_1', label: '用户场景'},
                {type: 'BDRULE_2', label: '数据实体'},
                {type: 'DT_1', label: '数据表'},
                {type: 'UC_1', label: '集成用例'},
            ],
        },
    ]
}

export const menuItemsInsertModule = (map) => {
    const {subTypeCode} = map.data

    if ('BODA1' === subTypeCode) {
        return [
            {
                type: '_O',
                label: '组织模件',

                children: [
                    {type: 'OU'},
                    {type: 'OR'},
                ],
            },

            {
                type: '_C',
                label: '流程模件',

                children: [
                    {type: 'BF'},
                    {type: 'BFDATAFLOW'},
                ],
            },

            {
                type: '_B',
                label: '业务模件',

                children: [
                    {type: 'BD'},
                    {type: 'BDSUMMARY'},
                    {type: 'BDRULE_1'},
                    {type: 'BDRULE_3'},
                    {type: 'BDRULE'},
                    {type: 'BDLOGIC'},
                    {type: 'BDEVENT'},
                    {type: 'BDALG_'},
                ],
            },

            {
                type: '_A',
                label: '分析模件',

                children: [
                    {type: 'DO'},
                    {type: 'DE'},
                    {type: 'IE'},
                    {type: 'AD'},
                    {type: 'ARRI'},
                ],
            },

            {
                type: '_U',
                label: '界面模件',

                children: [
                    {type: 'UI'},
                    {type: 'UV'},
                    {type: 'UIRULE'},
                    {type: 'UE_'},
                ],
            },

            {type: 'LSI'},
            {type: 'UC'},

            {
                type: '_D',
                label: '库表模件',

                children: [
                    {type: 'DT'},
                    {type: 'DV'},
                    {type: 'CDT'},
                ],
            },

            {type: 'FC'},
        ]
    }
    else {
        return [
            {
                type: '_O',
                label: '组织模件',

                children: [
                    {type: 'OU'},
                    {type: 'OR'},
                ],
            },

            {type: 'RULEMRMRULE_1'},

            {
                type: '_C',
                label: '流程模件',

                children: [
                    {type: 'BF'},
                    {type: 'BFDATAFLOW'},
                ],
            },

            {
                type: '_B',
                label: '功能模件',

                children: [
                    {type: 'BD'},
                    {type: 'BDSUMMARY'},
                    {type: 'BDRULE_1'},
                    {type: 'BDRULE_3'},
                    {type: 'BDRULE'},
                    {type: 'BDLOGIC'},
                    {type: 'BDEVENT'},
                    {type: 'BDALG_'},
                ],
            },

            {
                type: '_A',
                label: '分析模件',

                children: [
                    {type: 'DO'},
                    {type: 'DE'},
                    {type: 'IE'},
                    {type: 'AD'},
                    {type: 'ARRI'},
                ],
            },

            {
                type: '_U',
                label: '界面模件',

                children: [
                    {type: 'UI'},
                    {type: 'UV'},
                    {type: 'UIRULE'},
                    {type: 'UE_'},
                ],
            },

            {type: 'LSI'},
            {type: 'UC'},

            {
                type: '_D',
                label: '库表模件',

                children: [
                    {type: 'DT'},
                    {type: 'DV'},
                    {type: 'CDT'},
                ],
            },

            {type: 'FC'},
        ]
    }
}
